import React from 'react';

import {PublicEventsQuery} from '@/api';

type Event = NonNullable<
  NonNullable<PublicEventsQuery['publicEvents']>[number]
>;

type Props = {event: Event};

export const EventCard: React.FC<Props> = ({event}) => (
  <a
    href={`/events/${event.id}`}
    className="flex h-[400px] flex-col overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm transition-shadow hover:shadow-md">
    <div className="shrink-0">
      <img
        src={event.mainImageUrl ?? '/assets/Noimage-Top2.png'}
        alt={event.title ?? ''}
        className="aspect-[3/2] w-full object-cover"
      />
    </div>
    <div className="flex flex-1 flex-col p-4">
      <div className="mb-3">
        <time className="inline-flex items-center gap-1 text-xs font-semibold text-primary">
          <i className="fas fa-clock" aria-hidden="true" />
          {event.eventDateText}
          {event.eventDateWday && `（${event.eventDateWday}）`}
          {event.startTimeText && ` ${event.startTimeText}`}
        </time>
      </div>
      <h3 className="mb-auto line-clamp-2 font-semibold text-neutral-900">
        {event.title}
      </h3>
      <div className="mt-10">
        {event.organizer && (
          <div className="mb-1">
            <p className="text-[10px] text-neutral-500">主催者</p>
            <p className="line-clamp-1 text-xs text-primary">
              {event.organizer}
            </p>
          </div>
        )}
        {event.group && (
          <div>
            <p className="text-[10px] text-neutral-500">主催グループ</p>
            <p className="line-clamp-1 text-xs text-primary">
              {event.group.name}
            </p>
          </div>
        )}
      </div>
    </div>
  </a>
);
